import { atom } from 'jotai'
import { featureFlagsSubscriptionAtom } from './subscription.atoms'

export const isNewBasketEnabledAtom = atom((get) => {
  const [{ data }] = get(featureFlagsSubscriptionAtom)
  const featureFlags = data?.feature_flags || []
  return !!featureFlags.find((ff) => ff.key === 'newBasket')?.enabled
})

export const isNewLayoutEnabledAtom = atom((get) => {
  const [{ data }] = get(featureFlagsSubscriptionAtom)
  const featureFlags = data?.feature_flags || []
  return !!featureFlags.find((ff) => ff.key === 'newLayout')?.enabled
})

export const isShowShippingTestsEnabledAtom = atom((get) => {
  const [{ data }] = get(featureFlagsSubscriptionAtom)
  const featureFlags = data?.feature_flags || []
  return !!featureFlags.find((ff) => ff.key === 'showShippingTests')?.enabled
})

export const isShowHolterAndBloodlabEnabledAtom = atom((get) => {
  const [{ data }] = get(featureFlagsSubscriptionAtom)
  const featureFlags = data?.feature_flags || []
  return !!featureFlags.find((ff) => ff.key === 'showHolterAndBloodlab')?.enabled
})

export const isFfLoadingAtom = atom((get) => {
  const [{ fetching }] = get(featureFlagsSubscriptionAtom)
  return !!fetching
})

export const isFfErrorAtom = atom((get) => {
  const [{ error }] = get(featureFlagsSubscriptionAtom)
  return !!error
})
